import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import ContactForm from '@/components/common/ContactForm';
import HeroSection from './HeroSection';
import MissionSection from './MissionSection';
import TeamSection from './TeamSection';
import StorySection from './StorySection';

const AboutPage = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Seo 
        title="Über uns | splusd-solutions - Digitalisierungsberatung & Softwareentwicklung"
        description="splusd-solutions ist deine Digitalisierungsberatung und Softwareentwicklung für maßgeschneiderte Lösungen. Erfahre mehr über unser Team, unsere Geschichte und unsere Mission."
        canonical="/about"
      />
      <Layout>
        <main>
          {/* Über splusd-solutions */}
          <HeroSection />          {/* Hero mit Vorstellung */}
          <MissionSection />       {/* Unsere Mission */}
          <TeamSection />          {/* Dennis & Simon im Detail + Freelancer */}
          <StorySection />         {/* Unsere Werte */}
          <ContactForm />          {/* Kontakt aufnehmen */}
        </main>
      </Layout>
    </>
  );
};

export default AboutPage; 